import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { AnimationComponent } from "../../core/loading-animation/animation/animation.component";
import { LoadingAnimationModule } from "../../core/loading-animation/loading-animation.module";




@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    AnimationComponent,
    LoadingAnimationModule
],
  exports: [DashboardComponent]
})
export class DashboardModule { }
